import './news_overview.scss';
import Pagination from './pagination';
import { get_offset, clear_el, create_element } from 'js/utils';
import { ajax } from 'js/functions';
import Hooks from 'classes/Hooks';

const hooks = new Hooks([]);

function init() {
	init_query();
	init_render();
	init_filters();
	init_scrolL_top();
	init_pagination();
}
init();

function init_query() {
	let query_args = {};

	const query = (callback) => {
		hooks.do('before/query');

		ajax('src/modules/news/overview/query_ajax', query_args, (res) => {
			hooks.do('query/result', res);
			if (typeof callback === 'function') callback(res);
		});
	};

	hooks.add('pagination/init', (pagination) => {
		pagination.hooks.add('set', (page) => {
			query_args.page = page;
			query();
		});
	});

	hooks.add('filter/category', (category) => {
		query_args = { category };
		query((res) => {
			hooks.do('filter/category/result', res);
		});
	});
}

function init_filters() {
	let current = null;

	const update_url = (category) => {
		const url = new URL(window.location.href);
		url.searchParams.delete('pp');
		url.searchParams.set('cat', category);

		history.pushState(null, '', url.href);
	};

	const init_button = (btn) => {
		const category = btn.dataset.value;

		if (btn.classList.contains('active')) {
			current = btn;
		}

		const filter = () => {
			if (btn.classList.contains('active')) return;
			if (current) current.classList.remove('active');
			current = btn;
			btn.classList.add('active');

			update_url(category);

			hooks.do('filter/category', category);
		};

		btn.addEventListener('click', filter);
	};

	document
		.querySelectorAll('.category_filter_buttons .btn')
		.forEach(init_button);
}

function init_pagination() {
	const pagination = new Pagination('.pagination', {});

	const update = (res) => {
		pagination.update(res.found_posts);
	};

	hooks.add('filter/category/result', update);
	hooks.do('pagination/init', pagination);
}

function init_scrolL_top() {
	const container = document.querySelector('.news_overview');

	const scroll_top = () => {
		window.scrollTo({
			top: get_offset(container).top - 220,
		});
	};

	hooks.add('pagination/init', (pagination) => {
		pagination.hooks.add('set', scroll_top);
	});
}

function init_render() {
	const el = document.querySelector('.news_overview');

	const render_items = (res) => {
		clear_el(el);

		res.items.forEach((item) => {
			el.append(get_item_html(item));
		});

		el.classList.remove('loading');
	};

	hooks.add('before/query', () => {
		el.classList.add('loading');
	});

	hooks.add('query/result', render_items);
}

function get_item_html(item) {
	const el = create_element('item_news');

	const image = create_element('image image_fit', el, null, 'a');
	image.href = item.link;
	image.innerHTML = item.image;

	const c2 = create_element('c2', el);

	create_element('date', c2, item.date);

	const title = create_element('title', c2, null, 'h3');
	const title_link = create_element('', title, item.title, 'a');
	title_link.href = item.link;

	create_element('excerpt', c2, item.excerpt);

	const btn_link = create_element('btn terrain xs', c2, 'Read Artcicle', 'a');
	btn_link.href = item.link;

	return el;
}
